import { t } from 'i18next';
import React from 'react';
import { Link } from 'react-router-dom';

export default function Footer() {
  return (
    <div className="px-4 py-2 bg-black text-white text-xs">
      <div className="max-w-5xl mx-auto flex flex-col space-y-2 sm:space-y-0 py-2 sm:py-0 sm:flex-row justify-between items-center font-light tracking-wide">
        <div>{t('copyText')}</div>
        <ul className="flex flex-col space-y-2 xs:space-y-0 xs:flex-row items-center xs:space-x-4 rtl:space-x-reverse">
          <li>
            <Link to="/privacy">{t('privacyPolicy')}</Link>
          </li>
          <li>
            <Link to="/terms">{t('termsAndConditions')}</Link>
          </li>
          <li>
            <Link to="/refund">{t('refundPolicy')}</Link>
          </li>
        </ul>
      </div>
    </div>
  );
}
